import { extractStatusCode, isSkippableError } from '@/utils/error-utils';

/** Background heartbeat timers: skip expected transport/auth noise in Datadog. */
export const shouldSkipHeartbeatErrorReporting = (err: unknown): boolean =>
  isSkippableError(err) || extractStatusCode(err) === 401;
